export const parseCLP = (value) => {
  if (value === null || value === undefined || value === '') return 0
  if (typeof value === 'number') return value
  const cleaned = String(value).replace(/[^\d]/g, '')
  return cleaned ? parseInt(cleaned, 10) : 0
}

export const formatCLP = (value) => {
  if (value === null || value === undefined || value === '') return ''
  const amount = typeof value === 'number' ? value : parseCLP(value)
  if (Number.isNaN(amount) || amount <= 0) return ''
  return amount.toLocaleString('es-CL')
}

export const formatCLPInput = (value) => {
  const amount = parseCLP(value)
  if (!amount) return ''
  return amount.toLocaleString('es-CL')
}
